var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('os-confirm-dialog',{ref:"confirm"}),_c('os-inform-dialog',{ref:"info"}),_c('os-snack-bar',{ref:"snackbar"}),_c('os-business-error-dialog',{ref:"businessError"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }